import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginResponse } from '../../models/login-response.model';
import { ApiResponse } from '../../models/api-response.model';
import { environment } from '../../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CompanyAdminService {
  private readonly apiUrl = `${environment.apiGatewayBaseUrl}/api/CompanyAdmins`;

  constructor(private http: HttpClient) { }

  OnboardCompanyInitialContactAdminAndNotifyAsync(companyId: number, dto: any): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(`${this.apiUrl}/${companyId}/initial-contact-admin`, dto);
  }

  OnboardCompanySuperAdminAndNotifyAsync(companyId: number, dto: any): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(`${this.apiUrl}/${companyId}/super-admin`, dto);
  }

  UpdateSuperAdminAndNotifyAsync(companyId: number, dto: any): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(`${this.apiUrl}/${companyId}/update-super-admin`, dto);
  }

}
